module.exports = __webpack_public_path__ + "assets/img/TBetMake_Logo-controlPanel.942cd958.png";